export enum NutriScoreCategoryIngredientCategory {
	StandardFood = 'StandardFood',
	DriedFood = 'DriedFood',
	StandardBeverage = 'StandardBeverage',
	ConcentradedBeverage = 'ConcentradedBeverage',
}
